import { Box, LinearProgress, Stack, Typography } from '@mui/material';

interface ExportFileProgressIndicatorProps {
  fileType: string;
  eta: string;
}

export const ExportFileProgressIndicator = ({
  fileType,
  eta,
}: ExportFileProgressIndicatorProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={1}
      height="100%"
    >
      <Box width={140}>
        <LinearProgress color="info" />
      </Box>
      <Box>
        <Typography variant="body2" color="info.dark" sx={{ width: '100%' }}>
          Exporting {fileType}
        </Typography>
        <Typography variant="body2" color="info.dark" sx={{ width: '100%' }}>
          (This takes ~{eta})
        </Typography>
      </Box>
    </Stack>
  );
};
